import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';
import type { TaxAndFeeInclusionPolicy } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/common.pb';

import STYLES from './PriceSummary.module.scss';

import { getPriceSummaryKey } from '@hotels-hotel-detail/utils/hotel-offers';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  priceType?: Nullable<string>;
  i18n: I18nService;
  secondaryStyle?: boolean;
  taxAndFeeInclusionPolicy?: TaxAndFeeInclusionPolicy;
};

const PriceSummary = ({
  i18n,
  priceType,
  secondaryStyle,
  taxAndFeeInclusionPolicy,
}: Props) => {
  const priceSummaryKey = getPriceSummaryKey({
    taxAndFeeInclusionPolicy,
    priceType,
  });
  const priceSummary = i18n.translate(priceSummaryKey);

  return (
    <BpkText
      textStyle={
        secondaryStyle ? TEXT_STYLES.footnote : TEXT_STYLES.bodyDefault
      }
      tagName="p"
      data-testid="price-comparison-summary"
      className={secondaryStyle ? STYLES.PriceSummary : null}
    >
      {priceSummary}
    </BpkText>
  );
};

export default withI18n(PriceSummary);
